export default __webpack_public_path__ + "static/media/Extras_Receita_BiscoitoAmanteigado.6afe9788.jpg";